export const QUERY_PARAMS_TEMPLATES = {
    KEY_NAME: "demo_template",
    TOKEN: "token"
  }